import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { Container, NameBenefit, Circle } from './styles';

function CardBenefits({ name, icon, primaryColor }) {
  return (
    <Container primaryColor={primaryColor}>
      <Circle>
        <FontAwesomeIcon icon={icon} />
      </Circle>
      <NameBenefit>{name}</NameBenefit>
    </Container>
  );
}

export default CardBenefits;
